export default __webpack_public_path__ + "static/media/env.9dd77964.wav";